import { tokens } from './tokens';

// Helpers for Phaser (numbers, not strings)
export const hex = (s: string): number => parseInt(s.replace('#', ''), 16);

export const palette = {
  bgFrom:     hex(tokens.colors.bg.from),
  bgTo:       hex(tokens.colors.bg.to),
  ballCore:   hex(tokens.colors.ball.core),
  ballHalo:   hex(tokens.colors.ball.halo),
  barStroke:  hex(tokens.colors.bar.stroke),
  barGlow:    hex(tokens.colors.bar.glow),
  holeFill:   hex(tokens.colors.hole.fill),
  holeRim:    hex(tokens.colors.hole.rim),
  targetCore: hex(tokens.colors.target.core),
  targetHalo: hex(tokens.colors.target.halo),
  uiText:     hex(tokens.colors.ui.text),
  uiTextMuted: hex(tokens.colors.ui.textMuted),
  uiAccent:   hex(tokens.colors.ui.accent),
  uiBgChip:   hex(tokens.colors.ui.bgChip),
  failTint:   hex(tokens.colors.fail.tint)
} as const;
